<template>
  <div :style="{ zoom: zoomRatio, border: `1px solid ${stripeInnerBorderC}`, borderRadius: `${Math.floor(lfs * 0.8)}px`, marginBottom: `${lfs}px`, marginTop: `${lfs}px` }">
    <div :id="`wt3line_${id}`" :style="{ width: w + 'px', height: h1 + 'px'}">
    </div>
    <div :id="`wt3line_p2_${id}`" :style="{ width: w + 'px', height: (h2 - lfs * 2) / 2 + 'px'}">
    </div>
    <div :id="`wt3line_p3_${id}`" :style="{ width: w + 'px', height: (h2 / 4 + lfs * 2) + 'px'}">
    </div>
    <div class="legend legend--row1">
      <!-- <wt-legend> -->
      <!--   <template slot="icon"> -->
      <!--     <svg-icon icon-class="circle-highcolor" /> -->
      <!--   </template> -->
      <!--   {{$t('AiDEX High BG')}} -->
      <!-- </wt-legend> -->
      <!-- <wt-legend> -->
      <!--   <template slot="icon"> -->
      <!--     <svg-icon icon-class="circle-normalcolor" /> -->
      <!--   </template> -->
      <!--   {{$t('AiDEX Normal BG')}} -->
      <!-- </wt-legend> -->
      <!-- <wt-legend> -->
      <!--   <template slot="icon"> -->
      <!--     <svg-icon icon-class="circle-lowcolor" /> -->
      <!--   </template> -->
      <!--   {{$t('AiDEX Low BG')}} -->
      <!-- </wt-legend> -->      
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="triangle-highcolor" />
        </template>
        {{$t('CGMs High BG')}}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="triangle-normalcolor" />
        </template>
        {{$t('CGMs Normal BG')}}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="triangle-lowcolor" />
        </template>
        {{$t('CGMs Low BG')}}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="rect-highcolor" />
        </template>
        {{$t('Pump High BG')}}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="rect-normalcolor" />
        </template>
        {{$t('Pump Normal BG')}}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="rect-lowcolor" />
        </template>
        {{$t('Pump Low BG')}}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="diamond-highcolor" />
        </template>
        {{$t('BG High BG')}}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="diamond-normalcolor" />
        </template>
        {{$t('BG Normal BG')}}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="diamond-lowcolor" />
        </template>
        {{$t('BG Low BG')}}
      </wt-legend>
    </div>
    <div class="legend legend--row2">
      <div style="color: #485465;display: inline-block">
        {{ $t('Event Marker') }}
      </div>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="drug" />
        </template>
        {{$t('Medicine')}}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="apple" />
        </template>
        {{$t('Carbs')}}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="needle" />
        </template>
        {{$t('Insulin')}}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="sport" />
        </template>
        {{$t('Exercise')}}
      </wt-legend>
    </div>
  </div>
</template>
<script>
import reDrawTrigger from '@mx/reDrawTrigger'
import wtLegend from '@c/Legend'
import dayjs from 'dayjs'
import $ from 'jquery'
import * as d3 from 'd3'
import { getSymbol } from './getSymbol'
import { readableWeek } from '@/filters'
import { qcopy, isHighGlu, isLowGlu } from '@u'
// import { errorFactory, derrorFactory, dlogFactory } from '@u/log'
// const error = errorFactory('chart3line', false)
// const derror = derrorFactory('chart3line', true)
// const log = dlogFactory('chart3line', true)
import { derrorFactory, errorFactory } from '@u/log'
const error = errorFactory('chart3line', true)
const derror = derrorFactory('chart3line', true)

let _id = 1
export default {
  name: 'CChart3line',
  mixins: [reDrawTrigger],
  props: {
    noHorizontalSplitLine: {
      type: [Boolean],
      default: false
    },
    value: {
      type: [Object],
      default: () => {}
    }
  },
  components: {
    wtLegend
  },
  data() {
    _id++
    const id = `c3line_${+new Date()}_${_id}`
    return {
      id
    }
  },
  computed: {
    w() {
      const ds = this.ds
      return Math.floor(ds * (1685 / 1740))
    },
    h1() {
      const w = this.w
      const r = 196 / 1685
      return Math.round(r * w) * 2
    },
    h2() {
      const w = this.w
      const r = 100 / 1685
      return Math.round(r * w) * 2
    }
  },
  mounted() {
    this.render3lines(false)
    // this.renderLegends(false)
  },
  methods: {
    getSeriesFromDataSource(what) {
      const { cmax, cmaxC, cmin, cminC, normalC, stripeBgC, stripeInnerBorderC, lfw, lfs, largerRatio, unit, ds, value, isUnitMg } = this
      const { date } = value
      const nowT = dayjs()
      const startOfDay = nowT.startOf('day')
      
      const labelCom = {
        fontSize: (14 / 12 * lfs),
        padding: [2, 2],
        borderRadius: [2, 2, 2, 2]
      }
      
      const _seriesCom = {
        name: 'circle',
        type: 'line',
        lineStyle: {
          color: 'black',
          width: 1,
          type: 'solid'
        },
        label: { // 数值、矩形底
          show: true,
          position: 'right',
          color: 'white',
          distance: 15,
          offset: [-2, 0],
          formatter: 'functionPlaceHolder',
          rich: {
            placeholder: Object.assign({}, labelCom, {
              backgroundColor: 'transparent',
              opacity: 0
            }),
            normal: Object.assign({}, labelCom, {
              backgroundColor: normalC,
            }),
            max: Object.assign({}, labelCom, {
              backgroundColor: cmaxC
            }),
            min: Object.assign({}, labelCom, {
              backgroundColor: cminC
            })
          },
        },
        symbol: '',
        symbolSize: '',
        itemStyle: {
          color: 'functionPlaceHolder'
        },
        data: []
      }
      
      const series = []
      
      const { bloodGlucoseRecord = [] } = value
      const data = bloodGlucoseRecord
      // 生成series
      const afterD = _dataConverter(data)
      afterD.sort((first, second) => first[0] - second[0]) // 按照时间升序
      derror(`data `, data)
      derror(`after data `, afterD)

      const _s1 = Object.assign({}, qcopy(_seriesCom), {
        data: afterD,
        name: `glucoseline`
      })
      
      if (afterD && afterD.length === 0) {
        // 压入一个占位数据，否则整个表格一片白
        error(`压入一个占位数据，否则整个表格一片白`)
        afterD.push([+(dayjs(date).add(3, 'hour')), cmax + 0.1, undefined, true]) // 数值必须大于cmax,这样子才能将2条分界线渲染出来(这可能是因为我yaxis没有设置max的原因导致的?)
      }
      
      _s1.label.formatter = _labelFormatter
      _s1.itemStyle.color = _itemStyleColor
      _s1.symbol = _symbolFormatter
      _s1.symbolSize = _symbolSizeFomatter
      series.push(_s1)
      
      derror(`[Chart3Line]${what},series: `, series)
      // derror(`series: ${JSON.stringify(series)}`)
      return series
      
      function _dataConverter(data) {
        return data.map((d, i) => [
          +dayjs(d.testTimeStr),
          isUnitMg ? (+d.bloodGlucose).toFixed(0) : (+d.bloodGlucose).toFixed(1),
          d.dataOrigin
        ])
      }
      
      function _labelFormatter(params = {}) {
        const { data = [] } = params
        // derror(`formatter, v: ${JSON.stringify(v)}, params: ${params}`)
        const v = data[1]
        const isPlaceholder = !!data[3]
        if (isPlaceholder) {
          return `{placeholder|${v}}`
        }
        let what = 'normal'
        if (isHighGlu(v)) {
          what = 'max'
        } else if (isLowGlu(v)) {
          what = 'min'
        }
        return `{${what}|${v}}`
      }
      
      function _symbolFormatter(data = []) {
        const _d = ''
        // derror(`_symbolFormatter, data:`, data)
        let what = data[2] // 是数字; 0: pump, 1: bg, 2: aidex;3:cgm
        // derror(`_symbolFormatter, what:`, what)
        if (what === undefined) {
          what = _d
        } else {
          const _map = ['emptyrect', 'emptydiamond', 'emptycircle', 'emptytriangle'] // pump, bg, aidex, cgm
          what = _map[what]
          if (what === undefined) {
            what = _d
          }
        }
        
        // derror(`_symbolFormatter, rst: ${what}`)
        return what
      }
      
      function _symbolSizeFomatter(data = []) {
        const isPlaceholder = !!data[3]
        if (isPlaceholder) {
          return 0
        } else {
          return 10
        }
      }
      
      function _itemStyleColor(params) {
        // derror(`_itemStyleColor`)
        const { data = [] } = params || {}
        const v = data[1]
        
        let rst = normalC
        if (isHighGlu(v)) {
          rst = cmaxC
        } else if (isLowGlu(v)) {
          rst = cminC
        }
        return rst
      }
    },
    getCommonGridOpt(what) {
      const { lfs, ds } = this
      const uiW = 1754
      const oneHourW = 45.35 / uiW * ds
      const grid = {
        left: (64 / 12) * lfs,
        bottom: lfs * 2,
        // top: ((34 + 2) / 12) * lfs
        top: (((34 + 2) / 12) + 2) * lfs
      }
      grid.right = oneHourW * (45 / 47.19)

      if (what === 'co') {
        grid.bottom = 0
      }
      
      return grid
    },
    refreshTriggered() {
      // console.error(`Char3line ${this.id}, this.refreshTriggered`)
      this.render3lines(true)
      // this.renderLegends(true)
    },
    // renderLegends(isUpdate = false) {
    //   const { id, cmaxC, cminC } = this
    //   // console.error(`id: ${id}`)
    //   const legendId = `wt3line_l_${id}`
    //   const $legend = d3.select(`#${legendId}`)
    //   const svgId = `wt3line_l_svg_${id}`
    
    //   const svg = isUpdate ? $legend.select(`#${svgId}`) : $legend.append('svg')
    
    //   svg.attr('width', 500)
    //     .attr('height', 40)
    
    //   if (!isUpdate) {
    //     svg.attr('id', svgId)
    //   }
    
    //   const gId = `wt3line_l_svg_g_${id}`
    //   const chartG = isUpdate ? svg.select(`#${gId}`) : svg.append('g')
    //   if (!isUpdate) { // 第一次(init)
    //     chartG.attr('id', gId)
    //   }
    
    //   const textW = 10
    //   const y = 10
    
    //   chartG.selectAll('text')
    //     .data([
    //       {
    //         text: '------',
    //         x: 2 * textW,
    //         y,
    //         color: cmaxC
    //       },
    //       {
    //         text: 'Threshold of low BG',
    //         color: '#333',
    //         x: 6 * textW,
    //         y
    //       },
    //       {
    //         text: '------',
    //         color: cminC,
    //         x: 18 * textW,
    //         y
    //       },
    //       {
    //         text: 'Threshold of high BG',
    //         color: '#333',
    //         y,
    //         x: 22 * textW
    //       }
    //     ])
    //     .join('text')
    //     .join('text')
    //     .text(d => d.text)
    //     .attr('font-size', d => `${d.fs ? d.fs : 10}`)
    //   // .attr('style', d => `text-anchor: ${d.anchor ? d.anchor : 'end'}`)
    //     .attr('x', d => {
    //       return d && d.marginLeft ? (d.x - 0 + 10) : d.x
    //     })
    //     .attr('y', d => d.y)
    //     .attr('fill', d => d.color)
    // },
    render3lines(isUpdate = false) {     
      // const { id } = this
      // const ds = this.ds
      if (!isUpdate) {
        this.initChart()
      } else {
        this.updateChart()
      }
    },
    getOpt(what) {
      const { value, cmax, cmaxC, cmin, cminC, lfw, lfs, unit, noHorizontalSplitLine } = this
      const { date } = value      
      
      const grid = this.getCommonGridOpt()
      grid.bottom = 0
      
      const series = (this.getSeriesFromDataSource(what))
      
      series.unshift({ // 高低血糖的境界的横线
        type: 'line',
        data: [],
        lineStyle: {
          width: 2
        },
        symbol: 'none',
        smooth: true,
        markLine: {
          symbol: 'none',
          data: [
            {
              silent: true, // 鼠标悬停事件  true没有，false有
              lineStyle: {
                type: 'dashed',
                color: cmaxC,
                width: 1
              },
              label: {
                show: true,
                position: 'start',
                distance: [6, 0],
                color: cmaxC,
                fontWeigt: lfw
              },
              yAxis: cmax // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
            },
            {
              silent: true, // 鼠标悬停事件  true没有，false有
              lineStyle: {
                type: 'dashed',
                color: cminC,
                width: 1
              },
              label: {
                show: true,
                position: 'start',
                distance: [6, 0],
                color: cminC,
                fontWeigt: lfw
              },
              yAxis: cmin
            }
          ]
        },
        markArea: { // 高亮高低血糖中间
          itemStyle: {
            color: 'rgba(187, 234, 139, 0.20)',
            borderColor: '#abccba',
            borderWidth: 0
          },
          data: [
            [{ yAxis: cmin }, { yAxis: cmax }]
          ]
        }
      })
      const xAxis = [
        {
          boundaryGap: false,
          type: 'time',
          splitLine: {
            show: false
          },
          min: +dayjs(date).startOf('day'),
          max: +dayjs(date).add(1, 'day').startOf('day'),
          axisLine: {
            show: false,
            lineStyle: {
              color: this.stripeInnerBorderC
            },
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false,
            showMaxLabel: false
          }
        },
        {
          position: 'top',
          boundaryGap: false,
          type: 'time',
          splitLine: {
            show: false
          },
          min: +dayjs(date).startOf('day'),
          max: +dayjs(date).add(1, 'day').startOf('day'),
          axisLine: {
            show: true,
            lineStyle: {
              color: this.stripeInnerBorderC
            },
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false,
            showMaxLabel: false
          }
        }
      ]
      if (noHorizontalSplitLine) { // 画一个顶部的线，从而有border效果
        xAxis.push({
          type: 'time',
          position: 'top',
          splitLine: {
            show: false
          },
          axisLine: {
            onZero: false, // 默认是true,会导致position: top无效，一直显示在底部
            show: true,
            lineStyle: {
              color: this.stripeInnerBorderC
            },
          },
          axisLabel: {
            show: false,
            showMaxLabel: false
          },
          axisTick: {
            show: false,
            lineStyle: {
              color: 'red'
            }
          },
          minorTick: {
            show: false
          }
        })
      }
      const option = {
        animation: false,
        grid,
        xAxis,
        yAxis: [
          {
            type: 'value',
            min: 0,
            // max: 20,
            splitNumber: 3,
            nameGap: 15,
            name: unit,
            nameTextStyle: {
              color: 'black',
              padding: [0, 0, 0 - 0.8 * lfs, 0 - 6.8 * lfs]
            },
            minorTick: {
              show: false
            },
            splitLine: {
              show: !noHorizontalSplitLine,
              lineStyle: {
                color: this.stripeInnerBorderC
              }
            },
            splitArea: {
              show: true,
              areaStyle: {
                // 使用深浅的间隔色
                color: ['white', this.stripeBgC],
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: this.stripeInnerBorderC
              },
            },
            axisLabel: {
              show: true,
              showMaxLabel: true,
              color: 'black',
            },
            axisTick: {
              show: true, // 不显示刻度
            }
          },
          { // 用来显示日期时间等
            type: 'value',
            min: 0,
            nameGap: 15,
            position: 'left',
            name: `${dayjs(date).format('MM/DD/YYYY')} ${readableWeek(dayjs(date))}`,
            nameTextStyle: {
              color: '#141414',
              fontSize: 20,
              fontWeight: 'bold',
              padding: [3, 4, lfs * 0.8, lfs * 16]
            },
            minorTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            splitArea: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              show: false,
              showMaxLabel: false,
              color: 'black',
            },
            axisTick: {
              show: false, // 不显示刻度
            }
          },
          {
            type: 'value',
            min: 0,
            // max: 20,
            position: 'right',
            minorTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: this.stripeInnerBorderC
              },
            },
            axisLabel: {
              show: false,
              showMaxLabel: false
            },
            axisTick: {
              show: false, // 不显示刻度
            }
          }
        ],
        series
      }
      derror(`getOpt, option`, option)
      // derror(JSON.stringify(option))
      return option
    },
    getChartWithIconOptCo() {
      const { cmax, cmaxC, cmin, cminC, lfw, lfs, unit, value = {}} = this
      const { date } = value
      
      const _coKey = 'carbsRecord'      
      const _coDatas = value[_coKey].map(v => {
        const rst = [
          +dayjs(v.dateTimeStr),
          this.$t('CO'),
          v.statusShort1
        ]
        return rst
      })
      
      const grid = this.getCommonGridOpt('co')
      grid.top = 0
      const option = {
        animation: false,
        grid,
        xAxis: [
          {
            boundaryGap: false,
            type: 'time',
            splitLine: {
              show: false
            },
            min: +dayjs(date).startOf('day'),
            max: +dayjs(date).add(1, 'day').startOf('day'),
            axisLine: {
              show: true,
              lineStyle: {
                color: this.stripeInnerBorderC
              },
            },
            axisTick: {
              show: true,
              lineStyle: {
                color: 'black',
              }
            },
            axisLabel: {
              showMaxLabel: true,
              color: 'black',
              formatter: (v, i) => {
                const tmp = dayjs(v).format('HH:mm')
                
                return (tmp === '00:00' && i > 1) ? '24:00' : tmp
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'category',
            data: [
              this.$t('CO')
            ],
            boundaryGap: true,
            nameGap: 0,
            name: '0',
            nameTextStyle: {
              color: 'black',
              padding: [0, 24, (0 - Math.round(lfs / 2)), 0]
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: this.stripeInnerBorderC
              }
            },
            splitArea: {
              show: true,
              areaStyle: {
                // 使用深浅的间隔色
                color: [this.stripeBgC]// ,
                // color: [this.stripeBgC, 'rgba(165, 203, 184, .5)'],
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: this.stripeInnerBorderC
              },
            },
            axisLabel: {
              show: true,
              showMaxLabel: true,
              verticalAlign: 'center',
              color: 'black',
            },
            axisTick: {
              show: true, // 不显示刻度
            }
          },
          {
            type: 'category',
            data: [
              this.$t('CO')
            ],
            // max: 20,
            position: 'right',
            minorTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: this.stripeInnerBorderC
              },
            },
            axisLabel: {
              show: false,
              showMaxLabel: false
            },
            axisTick: {
              show: false, // 不显示刻度
            }
          }
        ],
        series: [
          {
            name: 'co-line',
            type: 'line',
            lineStyle: {
              show: false,
              width: 0
            },
            label: {
              show: true,
              position: 'right',
              color: 'black',
              offset: [-2, 0],
              formatter: (params) => {
                const { data } = params
                return data[2]
              }
            },
            symbolSize: 0,
            data: _coDatas
          }
        ]
      }
      derror(`getOptWithIconCo, option`, option)

      return option
    },
    getChartWithIconOptEvent() {
      const { cmax, cmaxC, cmin, cminC, lfw, lfs, unit, value = {}} = this
      const { date } = value
      
      // const _eventKeys = ['exerciseRecord', 'dietRecord', 'bloodGlucoseRecord', 'insulinRecord', 'medicationRecord']
      const _eventDatas = []
      const _eventKeys = ['exerciseRecord', 'dietRecord', 'insulinRecord', 'medicationRecord']
      const _eventKey2Type = ['excercise', 'Carbs', 'alert', 'medicine']
      const _eventKey2TimeKey = ['startTimeStr', 'mealTimeStr', 'injectionTimeStr', 'takenTimeStr']
      // const _eventKey2ValueKey = ['intensity', 'carbohydrate', 'insulinDosage', 'medicineDosage']
      
      _eventKeys.forEach((k, i) => {
        const arr = value[k] || []
        
        const narr = arr.forEach((v, j) => {
          const etype = _getEventType(k)
          const timekey = _eventKey2TimeKey[i]
          const dtime = v[timekey]
          
          if (undefined === dtime) {
            error(`获取event数据的时间失败, event type: ${etype}, timekey: ${timekey}, v: ${JSON.stringify(v)}`)
            return
          }
          
          _eventDatas.push([
            +dayjs(dtime),
            '',
            etype
          ])
        })
      })
      
      function _getEventType(key) {
        if (!_eventKeys.includes(key)) {
          error(`未知的event type, key: ${key}`)
          return ''
        }
        
        const i = _eventKeys.indexOf(key)
        return _eventKey2Type[i]
      }
      
      const grid = this.getCommonGridOpt()
      grid.top = 0
      const option = {
        animation: false,
        grid,
        xAxis: [
          {
            boundaryGap: false,
            type: 'time',
            splitLine: {
              show: false
            },
            min: +dayjs(date).startOf('day'),
            max: +dayjs(date).add(1, 'day').startOf('day'),
            axisLine: {
              show: true,
              lineStyle: {
                color: this.stripeInnerBorderC
              },
            },
            axisTick: {
              show: true,
              lineStyle: {
                color: 'black',
              }
            },
            axisLabel: {
              showMaxLabel: true,
              color: 'black',
              formatter: (v, i) => {
                const tmp = dayjs(v).format('HH:mm')
                
                return (tmp === '00:00' && i > 1) ? '24:00' : tmp
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'category',
            data: [
              this.$t('Event')
            ],
            boundaryGap: true,
            nameGap: 0,
            name: '0',
            nameTextStyle: {
              fontSize: 0,
              color: 'black',
              padding: [0, 24, (0 - Math.round(lfs / 2)), 0]
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: this.stripeInnerBorderC
              }
            },
            splitArea: {
              show: true,
              areaStyle: {
                // 使用深浅的间隔色
                // color: ['white', this.stripeBgC]// ,
                color: ['white']// ,
                // color: [this.stripeBgC, 'rgba(165, 203, 184, .5)'],
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: this.stripeInnerBorderC
              },
            },
            axisLabel: {
              show: true,
              showMaxLabel: true,
              verticalAlign: 'center',
              color: 'black',
            },
            axisTick: {
              show: true, // 不显示刻度
            }
          },
          {
            type: 'category',
            data: [
              this.$t('Event')
            ],
            // max: 20,
            position: 'right',
            minorTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: this.stripeInnerBorderC
              },
            },
            axisLabel: {
              show: false,
              showMaxLabel: false
            },
            axisTick: {
              show: false, // 不显示刻度
            }
          }
        ],
        series: [
          {
            name: 'event-line',
            // type: 'line',
            type: 'line',
            showBackground: true,
            lineStyle: {
              width: 0
            },
            showSymbol: true,
            symbol: (value, params) => {
              const eventType = value[2]
              const symbol = getSymbol(eventType)
              // if (eventType) {
              //   derror(`symbol, getSymbol result: ${symbol}, eventType: ${eventType}`)
              // }
              return symbol
            },
            symbolSize: 20,
            smooth: true,
            data: _eventDatas
          }
        ]
      }
      derror(`getOptWithIconEvent, option`, option)

      return option
    },
    initChart() {
      const { id } = this
      const canvasid = `wt3line_${id}`
      const canvasid2 = `wt3line_p2_${id}`
      const canvasid3 = `wt3line_p3_${id}`
      try {
        const myChart = this.$echarts.init(document.getElementById(`${canvasid}`), null, { renderer: 'svg' })
        const opt = this.getOpt('initChart')
        
        myChart.setOption(opt)

        const myChart2 = this.$echarts.init(document.getElementById(`${canvasid2}`), null, { renderer: 'svg' })
        const opt2 = this.getChartWithIconOptCo()
        
        myChart2.setOption(opt2)

        const myChart3 = this.$echarts.init(document.getElementById(`${canvasid3}`), null, { renderer: 'svg' })
        const opt3 = this.getChartWithIconOptEvent()
        
        myChart3.setOption(opt3)
        
        this._myCharts = [myChart, myChart2, myChart3]
      } catch (error) {
        console.error('被捕获:' + error)
      }
    },
    updateChart() {
      const myChart = this._myCharts[0]
      const newOpt = this.getOpt('updateChart')

      const myChart2 = this._myCharts[1]
      const newOpt2 = this.getChartWithIconOptCo()

      const myChart3 = this._myCharts[2]
      const newOpt3 = this.getChartWithIconOptEvent()
      
      this.$nextTick(() => {
        try {
          if (myChart) {
            myChart.setOption(newOpt)            
          }
          if (myChart2) {
            myChart2.setOption(newOpt2)
          }
          if (myChart3) {
            myChart3.setOption(newOpt3)
          }
        } catch (error) {
          console.error('被捕获:' + error)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables';
$pl: $sizePaddingTopLegend;
.legend {
    margin-left: $pl * 2;
    &.legend--row2 {
        margin-top: $pl;
        margin-bottom: $pl + 4px;
    }
    ::v-deep > .wtLegend-ctn {
        margin-left: $pl;
        &:first-child {
            margin-left: 0;
        }
    }
}
</style>
